import { Container } from "./styles";

const MiniCaption = ({
    variant = "primary",
    text
}) => {
    return (
        <Container className={variant}>
            <span>{text}</span>
        </Container>
    );
}

export default MiniCaption;